import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

const ContractSubtitle = ({ data }) => (
  <Typography
    variant="heading4"
    color="black.default"
  >
    {data}
  </Typography>
);

ContractSubtitle.propTypes = {
  data: PropTypes.string.isRequired,
};

export default ContractSubtitle;
